import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import './styles.css';
import EconomicChart from '../EconomicChart';

class IncomeStatement extends Component {
	render() {
		const {
			cashFlowStatement: {
				netIncome,
				fixedAssetsDepreciation,
				inventoryDelta,
				receivablesDelta,
				payablesDelta,
				cashFlowFromOperations,
				capitalExpenditures,
				longTermDebtDelta,
				shortTermDebtsDelta,
				equityDelta,
				totalCashFlow
			}
		} = this.props.game;

		const data = [
			{ label: 'Net Income', values: netIncome },
			{ label: 'Depreciation (total)', values: fixedAssetsDepreciation },
			{ label: '+ Δ inventory', values: inventoryDelta },
			{ label: '+ Δ receivables', values: receivablesDelta },
			{ label: '- Δ payables', values: payablesDelta },
			{
				label: 'Cash Flow from Operations (CFO)',
				values: cashFlowFromOperations
			},
			{ label: '-CAPEX', values: capitalExpenditures },
			{ label: '+ Long-term debt', values: longTermDebtDelta },
			{ label: '+ Short-term debt', values: shortTermDebtsDelta },
			{ label: "+ Common stockholders' equity", values: equityDelta },
			{ label: 'Total Cash', values: totalCashFlow }
		];

		return (
			<div className="income-statement">
				<EconomicChart data={data} />
			</div>
		);
	}
}

IncomeStatement.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		cashFlowStatement: PropTypes.shape({
			netIncome: MultiYearScalarType,
			fixedAssetsDepreciation: MultiYearScalarType,
			inventoryDelta: MultiYearScalarType,
			receivablesDelta: MultiYearScalarType,
			payablesDelta: MultiYearScalarType,
			cashFlowFromOperations: MultiYearScalarType,
			capitalExpenditures: MultiYearScalarType,
			longTermDebtDelta: MultiYearScalarType,
			shortTermDebtsDelta: MultiYearScalarType,
			equityDelta: MultiYearScalarType,
			totalCashFlow: MultiYearScalarType
		})
	})
};

export default IncomeStatement;
